import React from 'react'
import { useEffect, useState } from 'react'

interface ComplianceTimerProps {
    isUTC?: boolean
}

const ComplianceTimer: React.FC<ComplianceTimerProps> = ({ isUTC = false }) => {
    const getCurrentTime = () => {
        const now = new Date()
        const hours = (isUTC ? now.getUTCHours() : now.getHours()).toString().padStart(2, '0')
        const minutes = (isUTC ? now.getUTCMinutes() : now.getMinutes()).toString().padStart(2, '0')

        return `${hours}:${minutes}`
    }

    const [time, setTime] = useState(() => getCurrentTime())

    useEffect(() => {
        let timeoutId: number

        const updateClock = () => {
            setTime(getCurrentTime())

            const now = new Date()
            const secondsUntilNextMinute = 60 - now.getSeconds()

            timeoutId = window.setTimeout(updateClock, secondsUntilNextMinute * 1000)
        }

        updateClock()

        return () => {
            clearTimeout(timeoutId)
        }
    }, [isUTC])

    return <div className="text-[#555555] text-right">{time}</div>
}

export default ComplianceTimer
